import { IImageData, ImageRecord, StagedImagePayload } from "common/records/Image";
import { FormUpdateEvent } from "common/reducers/rsfForm.actions";
import { ITaskData } from "common/records/Task";
import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";
import { List } from "immutable";

export const FETCH_IMAGE = "@images/FETCH_IMAGE";
export const RECEIVE_IMAGE = "@images/RECEIVE_IMAGE";
export const RECEIVE_IMAGES = "@images/RECEIVE_IMAGES";
export const RECEIVE_IMAGE_OVERVIEW = "@images/RECEIVE_IMAGE_OVERVIEW";
export const RESET_IMAGE = "@images/RESET_IMAGE";
export const SET_IMAGE_LOADED = "@images/SET_IMAGE_LOADED";
export const SET_IMAGE_LOADING = "@images/SET_IMAGE_LOADING";
export const DESTROY_IMAGE = "@images/DESTROY_IMAGE";
export const REMOVE_IMAGE = "@images/REMOVE_IMAGE";
export const INCREASE_COUNT = "@images/INCREASE_COUNT";
export const RESET_COUNT = "@images/RESET_COUNT";
export const UPDATE_IMAGE_WITH_URLS = "@images/UPDATE_IMAGE_WITH_URLS";
export const RECEIVE_CUSTOMER_IMAGE_STATUS_BY_TASK_ID = "@images/RECEIVE_CUSTOMER_IMAGE_STATUS_BY_TASK_ID";
export const SET_CUSTOMER_IMAGES_ERROR = "@images/SET_CUSTOMER_IMAGES_ERROR";
export const EDIT_IMAGE = "@images/EDIT_IMAGE";
export const EDIT_IMAGES = "@images/EDIT_IMAGES";
export const EDIT_DISPLAY_BOOLEAN = "@images/EDIT_DISPLAY_BOOLEAN";
export const TOGGLE_ALL_IMAGES_DISPLAY = "@images/TOGGLE_ALL_IMAGES_DISPLAY";

// PRODUCT
export const PRODUCT_IMAGE = "@images/PRODUCT_IMAGE";
// ESTIMATE LINE ITEM
export const ESTIMATE_LINE_ITEM_IMAGE = "@images/ESTIMATE_LINE_ITEM_IMAGE";

export const ImageActions = {
  fetchImage: (id: number) => createAction(FETCH_IMAGE, { id }),
  receiveImage: (image: Partial<IImageData>, pushToList?: boolean) =>
    createAction(RECEIVE_IMAGE, { image, pushToList }),
  receiveImages: (images: Partial<IImageData>[]) => createAction(RECEIVE_IMAGES, { images }),
  receiveImageOverview: (image: Partial<IImageData>) => createAction(RECEIVE_IMAGE_OVERVIEW, { image }),
  resetImage: (id: number) => createAction(RESET_IMAGE, { id }),
  setImageLoaded: (id: number) => createAction(SET_IMAGE_LOADED, { id }),
  setImageLoading: (loading: boolean) => createAction(SET_IMAGE_LOADING, { loading }),
  destroyImage: (image: ImageRecord) => createAction(DESTROY_IMAGE, { image }),
  removeImage: (id: number) => createAction(REMOVE_IMAGE, { id }),
  increaseCount: () => createAction(INCREASE_COUNT),
  resetCount: () => createAction(RESET_COUNT),
  updateImageWithUrls: (id: number, results: any) => createAction(UPDATE_IMAGE_WITH_URLS, { id, results }),
  receiveCustomerImageStatusByTaskId: (task: ITaskData) =>
    createAction(RECEIVE_CUSTOMER_IMAGE_STATUS_BY_TASK_ID, { task }),
  setCustomerImagesError: (value: boolean) => createAction(SET_CUSTOMER_IMAGES_ERROR, { value }),
  editImage: (id: number, name: string, value: any) => createAction(EDIT_IMAGE, { id, name, value }),
  editImages: (ids: List<number>, name: string, value: any) => createAction(EDIT_IMAGES, { ids, name, value }),
  editDisplayBoolean: (event: FormUpdateEvent) => createAction(EDIT_DISPLAY_BOOLEAN, { event }),
  toggleAllImagesDisplay: (ids: List<number>, displayProp: string, value: boolean) =>
    createAction("@images/TOGGLE_ALL_IMAGES_DISPLAY", { ids, displayProp, value }),

  //PRODUCT
  productImage: (productId: number, image: Partial<IImageData>) => createAction(PRODUCT_IMAGE, { productId, image }),

  // ESTIMATE LINE ITEM
  estimateLineItemImage: (estimateLineItemId: number, image: StagedImagePayload) =>
    createAction(ESTIMATE_LINE_ITEM_IMAGE, { estimateLineItemId, image }),
};

export type ImageActions = ActionsUnion<typeof ImageActions>;
